<template>
  <div class="page-wrapper" id="storybook-preview-icons">
    <h1>{{ $t('icon') }}</h1>
    <TabMenu :menus="menus" class=" m-t-20"/>
    <StorybookTemplate>
      <component :is="childTag"/>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue'),
    TabMenu: () => import('../../../../components/TabMenu.vue')
  },
  data () {
    return {
      childTag: this.$store.state.framework === 'vue' ? 'router-view' : 'NChild'
    }
  },
  computed: {
    menus () {
      return [
        { name: 'Font Icons', exact: true, href: '/foundations/conicle-space-and-coniverse/design-elements/icons' },
        { name: 'SVG Icons', href: '/foundations/conicle-space-and-coniverse/design-elements/icons/svg-icons', forceActive: this.$route.path === '/components/conicle-space-and-coniverse/foundations/icons/svg-icons' },
        { name: 'Content Type Icons', href: '/foundations/conicle-space-and-coniverse/design-elements/icons/content-type', forceActive: this.$route.path === '/components/conicle-space-and-coniverse/foundations/icons/content-type' }
      ]
    }
  }
}
</script>
